var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleIcon = function SvgGoogleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G",
    transform: "translate(-398 -154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google__G__Logo",
    transform: "translate(398.632 154.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M-1089.33-687.239v4.492h6.243a5.348,5.348,0,0,1-2.331,3.491l3.765,2.921a11.334,11.334,0,0,0,3.459-8.531,13.329,13.329,0,0,0-.211-2.373Z",
    transform: "translate(1100.93 696.73)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M-1170.506-651.791l-.849.65-3.005,2.341h0a11.6,11.6,0,0,0,10.355,6.4,11.072,11.072,0,0,0,7.677-2.805l-3.765-2.921a6.909,6.909,0,0,1-3.912,1.118,6.925,6.925,0,0,1-6.5-4.777Z",
    transform: "translate(1175.605 665.599)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M-1183.333-712.61a11.456,11.456,0,0,0-1.244,5.2,11.457,11.457,0,0,0,1.244,5.2c0,.01,3.86-2.995,3.86-2.995a6.946,6.946,0,0,1-.369-2.2,6.946,6.946,0,0,1,.369-2.2Z",
    transform: "translate(1184.577 719.011)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M-1164.006-760.552a6.329,6.329,0,0,1,4.44,1.729l3.322-3.322a11.128,11.128,0,0,0-7.761-3.027,11.58,11.58,0,0,0-10.356,6.4l3.86,2.995a6.925,6.925,0,0,1,6.5-4.777Z",
    transform: "translate(1175.606 765.171)",
    fill: "#ea4335"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 24,
    height: 24,
    transform: "translate(398 154)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleIcon.b6323c9a.svg";
export { ForwardRef as ReactComponent };